import { useEffect, useState } from "react";
import type { Vehicle } from "@/v2/apis/vehicle/vehicle-apis";
import { useAppSelector } from "@/v2/hooks/useTypedRedux";
import type { PaginatedResponse } from "@/v2/queries/types";

export const useBikesResult = () => {
  const [bikesResult, setBikesResult] =
    useState<PaginatedResponse<Vehicle> | null>(null);
  const savedFilters = useAppSelector((state) => state.vehicle.bikesResult);

  useEffect(() => setBikesResult(savedFilters || null), [savedFilters]);

  return { bikesResult };
};
